module.exports = __webpack_public_path__ + "static/media/ico_simulation_face_cheek.8af6d15d.png";